export var NotificationDeliveryWindow;

(function (NotificationDeliveryWindow) {
  NotificationDeliveryWindow["STANDARD"] = "STANDARD";
  NotificationDeliveryWindow["TIMEZONE"] = "TIMEZONE";
  NotificationDeliveryWindow["INFORMED"] = "INFORMED";
})(NotificationDeliveryWindow || (NotificationDeliveryWindow = {}));